import { createAsyncThunk } from '@reduxjs/toolkit';
import { poolClient } from 'api/clients';
import { fetchPoolsSuccess, requestFailure, requestStart } from './poolSlice';

// Fetch all pools
export const fetchAllPoolsThunk = createAsyncThunk(
  'miner/fetchAllPools',
  async (_, { dispatch }) => {
    dispatch(requestStart());
    try {
      const pools = await poolClient.getPools();
      dispatch(fetchPoolsSuccess(pools));
    } catch (error) {
      dispatch(requestFailure(error.toString()));
    }
  }
);
